import { forwardRef } from 'react';

import { Icon, IconProps } from '@/component-library/Icon';

const LDOT = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon {...props} ref={ref} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <title>LDOT</title>
    <g clipPath='url(#clip0_401_11)'>
      <path
        d='M12 0.766663C18.204 0.766663 23.2333 5.796 23.2333 12C23.2333 18.204 18.204 23.2333 12 23.2333C5.796 23.2333 0.766663 18.204 0.766663 12C0.766663 5.796 5.796 0.766663 12 0.766663Z'
        fill='#E6007A'
        stroke='white'
      />
      <mask
        id='mask0_401_11'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='5'
        y='5'
        width='14'
        height='14'
      >
        <path d='M5.33331 5.33334H18.6666V18.6667H5.33331V5.33334Z' fill='white' />
      </mask>
      <g mask='url(#mask0_401_11)'>
        <path
          d='M11.9995 8.13014C13.4117 8.13014 14.5563 7.50401 14.5563 6.73174C14.5563 5.95948 13.4117 5.33334 12 5.33334C10.5877 5.33334 9.44321 5.95948 9.44321 6.73174C9.44321 7.50401 10.5872 8.13014 11.9995 8.13014ZM11.9995 18.6656C13.4117 18.6656 14.5563 18.0395 14.5563 17.2672C14.5563 16.4955 13.4117 15.8693 11.9995 15.8693C10.5872 15.8693 9.44267 16.4955 9.44267 17.2672C9.44267 18.0395 10.5872 18.6656 11.9995 18.6656ZM8.43627 10.0656C9.14241 8.91574 9.13761 7.67041 8.42561 7.28374C7.71414 6.89761 6.56481 7.51628 5.85921 8.66614C5.15307 9.81601 5.15734 11.0613 5.86934 11.448C6.58081 11.8341 7.73067 11.2155 8.43627 10.0656ZM18.1387 15.3328C18.8448 14.1829 18.8405 12.9381 18.1296 12.5515C17.4181 12.1653 16.2693 12.7845 15.5632 13.9344C14.8571 15.0843 14.8613 16.3291 15.5728 16.7157C16.2837 17.1019 17.4331 16.4827 18.1387 15.3328ZM8.42667 16.7152C9.13814 16.3291 9.14294 15.0832 8.43681 13.9339C7.73067 12.784 6.58081 12.1648 5.86934 12.5515C5.15787 12.9376 5.15307 14.1835 5.85921 15.3328C6.56534 16.4827 7.71521 17.1019 8.42667 16.7152ZM18.1301 11.448C18.8416 11.0619 18.8459 9.81708 18.1397 8.66721C17.4336 7.51734 16.2843 6.89814 15.5733 7.28428C14.8619 7.67041 14.8581 8.91521 15.5637 10.0651C16.2699 11.2155 17.4192 11.8341 18.1301 11.448Z'
          fill='white'
        />
      </g>
      <circle cx='18' cy='18' r='6' fill='#D9D9D9' />
      <path d='M16.6321 22V14.7273H18.1697V20.7322H21.2876V22H16.6321Z' fill='black' />
    </g>
    <defs>
      <clipPath id='clip0_401_11'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </Icon>
));

LDOT.displayName = 'LDOT';

export { LDOT };
